/**
* Image Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'image-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.image-marquee__splide' ).length ) {
        $( '.image-marquee__splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            autoWidth: true,
            arrows: false,
            pagination: false,
            drag: false,
            autoScroll: {
              pauseOnHover: false,
              pauseOnFocus: false,
              speed: 1,
            },
          } );
          splide.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-marquee', COMPONENT );
} )( app );
